import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function E() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('solar60w');

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.solar-60w-E',
            triggerHook: 1,
            offset: 180,
            onEnter: () => {
                const video1 = document.querySelector('.solar-60w-E .video1') as HTMLVideoElement;
                video1.play();
                const video2 = document.querySelector('.solar-60w-E .video2') as HTMLVideoElement;
                video2.play();
            },
            onLeave: () => {
                const video1 = document.querySelector('.solar-60w-E .video1') as HTMLVideoElement;
                video1.pause();
                video1.currentTime = 0;
                const video2 = document.querySelector('.solar-60w-E .video2') as HTMLVideoElement;
                video2.pause();
                video1.currentTime = 0;
            },
        });
    }, []);

    return (
        <div className={`solar-60w-E ${css['solar-60w-E']}`}>
            <div className="text-box">
                <p className="title">{t('sec5_title')}</p>
                <p className="desc">
                    {t.rich('sec5_desc', {
                        black: (text: string) => <span className="black">{text}</span>,
                    })}
                </p>
            </div>
            <div className="video-box">
                <div className="video">
                    <EFVideo
                        className="video1"
                        sources={['/video/solar-60w/pc/5_1.mp4']}
                        width="100%"
                        height="100%"
                        autoPlay={false}
                        aria-label={t('sec5_title')}
                        showReplay
                        loop={false}
                        replayIcon={{ fill: '#1A1A1A', stroke: 'transparent', circlefill: '#000', fillOpacity: '0.1' }}
                    />
                </div>
                <div className="video">
                    <EFVideo
                        className="video2"
                        sources={['/video/solar-60w/pc/5_2.mp4']}
                        width="100%"
                        height="100%"
                        autoPlay={false}
                        aria-label={t('sec5_title')}
                        showReplay
                        loop={false}
                        replayIcon={{ fill: '#1A1A1A', stroke: 'transparent', circlefill: '#000', fillOpacity: '0.1' }}
                    />
                </div>
            </div>
        </div>
    );
}
